import './footer.css';


const Footer = () => {
    return (
        <footer className='Footer'>
            <>
                <div>
                    <h3>24/7 Food Delivery in New York</h3>
                    <p>Working round-the-clock without weekends and holidays</p>
                    <a href='#'>info@fastfeast.com</a>
                </div>
            </>
        </footer>
    )
}
export default Footer;